import * as assetConstants from '../constants/assets';

const INITIAL_STATE = {
    loading: false,
    error: null,
    jobId: null,
    jobCount: null,
};

export default function exportProjectImages(state = INITIAL_STATE, action) {
    switch (action.type) {
        case assetConstants.EXPORT_PROJECT_IMAGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                jobId: null,
                jobCount: null,
            };

        case assetConstants.EXPORT_PROJECT_IMAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                jobId: action.payload.jobId,
                jobCount: action.payload.count,
            };

        case assetConstants.EXPORT_PROJECT_IMAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                jobId: null,
                jobCount: null,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/exportProjectImagesReducer.js